import React from "react";
import styled from "styled-components";
import axios from "axios";
import translate from "../../providers/i18n/translate";
import Modal from "../modal";
import { FormControl, IconButton, Input, InputAdornment, InputLabel, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ThemeContext } from "../../providers/theme";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/authentication";
import { useIntl } from "react-intl";
import { API_URL_UM } from "../../config";

const Root = styled.form`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80vw;
    height: auto;
    @media (min-width: 1024px) {
        width: 350px;
        min-height: 300px;
    }
    input:-webkit-autofill {
        transition: background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s;
        transition-delay: background-color 5000s, color 5000s;
    }
`

const Title = styled.h2`
    width: 60%;
    border-bottom: 1px solid rgba(0,0,0,0.8);
    text-transform: uppercase;
    text-align: center;
    line-height: 3rem;
    margin: 0 0 30px 0;
`

const StyledButton = styled.button`
    border-radius: 47px;
    background: ${(props) => props.bg ? props.bg : '#D2A757'};
    padding: 10px 30px;
    margin: 30px 0;
    box-shadow: none;
    user-select: none;
    outline: none;
    border: none;
    cursor: pointer;
    color: white;
`

const TextButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    text-decoration: underline;
    font-size: 0.875rem;
    margin-top: 8px;
`

const SuccessMessage = styled.div`
    margin-top: 16px;
    text-align: center;
    font-size: 0.875rem;
`

const Login = () => {

    const theme = React.useContext(ThemeContext);
    const intl = useIntl();

    let navigate = useNavigate();

    const { onLogin } = useAuth();

    const [ formData, setFormData ] = React.useState({
        username: '',
        password: ''
    })

    const [ forgotEmail, setForgotEmail ] = React.useState('');
    const [ showForgot, setShowForgot ] = React.useState(false);
    const [ forgotSubmitting, setForgotSubmitting ] = React.useState(false);
    const [ forgotSuccess, setForgotSuccess ] = React.useState(false);

    const [ showPassword, setShowPassword ] = React.useState(false);

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const submit = (e) => {
        e.preventDefault();
        onLogin({userName: formData.username, password: formData.password}, () => navigate("/backoffice/horses"));
    }

    const submitForgot = (e) => {
        e.preventDefault();
        setForgotSuccess(false);
        setForgotSubmitting(true);
        axios.post(`${API_URL_UM}/api/users/forgot-password`, { email: forgotEmail.trim() })
            .then(() => {
                setForgotSuccess(true);
            })
            .catch((err) => {
                alert(err.response?.data?.msg || intl.formatMessage({ id: 'forgotPasswordError' }));
            })
            .finally(() => setForgotSubmitting(false));
    }

    return (
        <Modal>
            <Root onSubmit={showForgot ? submitForgot : submit}>
                <Title>{showForgot ? translate("forgotPasswordTitle") : translate("login")}</Title>
                {showForgot ? (
                    <>
                        <TextField
                            label={translate("email")}
                            name="forgotEmail"
                            type="email"
                            value={forgotEmail}
                            onChange={(e) => setForgotEmail(e.target.value)}
                            variant="standard"
                            margin="normal"
                            fullWidth
                            autoComplete="email"
                        />
                        {forgotSuccess ? (
                            <SuccessMessage>{translate("forgotPasswordSuccess")}</SuccessMessage>
                        ) : null}
                        <StyledButton type="submit" disabled={forgotSubmitting} bg={theme.palette.accent}>
                            {translate("forgotPasswordSubmit")}
                        </StyledButton>
                        <TextButton type="button" onClick={() => { setShowForgot(false); setForgotSuccess(false); }}>
                            {translate("forgotPasswordBack")}
                        </TextButton>
                    </>
                ) : (
                    <>
                        <TextField label={translate("username")} name="username" type="text" value={formData.username} onChange={handleChange} variant="standard" margin="normal" fullWidth />
                        <FormControl variant="standard" fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">{translate("password")}</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                name="password"
                                type={showPassword ? 'text' : 'password'}
                                value={formData.password}
                                onChange={handleChange}
                                endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                                }
                            />
                        </FormControl>
                        <TextButton type="button" onClick={() => { setShowForgot(true); setForgotSuccess(false); }}>
                            {translate("forgotPasswordLink")}
                        </TextButton>
                        <StyledButton bg={theme.palette.accent}>{translate("loginbutton")}</StyledButton>
                    </>
                )}
            </Root>
        </Modal>
    );
}

export default Login;